// Manage Users URL filter: ?recentLimit=10–100 = newest N; no param = default view.

export const ALLOWED_RECENT_LIMITS = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

export function parseRecentLimitFromUrl() {
  const isBrowser = typeof window !== 'undefined';
  if (!isBrowser) {
    return null;
  }
  const params = new URLSearchParams(window.location.search);
  const value = parseInt(params.get('recentLimit'), 10);
  if (ALLOWED_RECENT_LIMITS.includes(value)) {
    return value;
  }
  return null;
}

export function recentLimitToQueryParam(recentLimit) {
  if (recentLimit && ALLOWED_RECENT_LIMITS.includes(recentLimit)) {
    return String(recentLimit);
  }
  return null;
}
